<template>
    <div>
        <v-dialog
            v-model="model"
            scrollable
            @click:outside="fecharModal"
            :persistent="persistencia"
            :max-width="maxWidth"
            style="padding: 0">
            <v-card>
                <v-toolbar dark color="primary" elevation="0">
                    <v-toolbar-title>Eventos ({{ moment(dataSelecionada).format('dddd, DD [de] MMMM') }})
                    </v-toolbar-title>
                    <v-spacer/>
                    <v-btn class="close__button" text @click="fecharModal" icon>
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container fluid grid-list-xl class="pt-0">
                    <v-card-text class="container-principal">
                        <div v-for="evento in eventosList" :key="evento.id" @click="abrirModalVisualizacao(evento)">
                            <div class="container-evento-item" :style="`--cor-dentista: ${evento.color}`">
                                <label class="d-inline-block text-truncate max-15">{{ evento.titulo }}</label>
                                <label>{{ moment(evento.start).format('HH:mm') }} -
                                    {{ moment(evento.end).format('HH:mm') }}</label>
                            </div>
                        </div>
                    </v-card-text>
                    <div>
                        <label>{{ eventosList.length }} eventos localizados!</label>
                    </div>
                </v-container>
            </v-card>
        </v-dialog>
        <ModalEventoAgenda
            v-if="modalEventoSelecionado"
            v-model="modalEventoSelecionado"
            :evento="eventoSelecionado"
            @modalEventoAcaoFechar="fecharModalEventoSelecionado"
            @modalEventoAcaoFecharAposAtualizar="fecharModalComAtualizacao"
        />
    </div>
</template>

<script>
import moment from 'moment'
import {actionTypes} from '@/core/constants'
import ModalEventoAgenda from '@/views/pages/agenda/ModalEventoAgenda.vue'

export default {
    name: 'ModalMaisEventos',
    components: {ModalEventoAgenda},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        dataSelecionada: {
            type: String,
            required: true
        },
        dentistaFiltroSelecionadoId: Number,
        pacienteFiltroSelecionadoId: Number,
        persistencia: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Number,
            default: 500
        }
    },
    data() {
        return {
            moment,
            eventosList: [],
            modalEventoSelecionado: false,
            eventoSelecionado: null,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    async mounted() {
        await this.buscarModalMaisEventos()
    },
    methods: {
        async buscarModalMaisEventos() {
            const input = {
                dentistaId: {value: this.dentistaFiltroSelecionadoId},
                pacienteId: {value: this.pacienteFiltroSelecionadoId},
                dataInicio: {value: moment(this.dataSelecionada).clone().startOf('day').format('YYYY-MM-DD HH:mm:ss')},
                dataFim: {value: moment(this.dataSelecionada).clone().endOf('day').format('YYYY-MM-DD HH:mm:ss')},
            }
            const resposta = await this.$store.dispatch(actionTypes.AGENDA.BUSCAR_EVENTOS, input)
            if (resposta) {
                this.eventosList = resposta.items
            }
        },
        fecharModal() {
            this.model = false
            this.$emit('modalMaisEventosAcaoFechar')
        },
        abrirModalVisualizacao(evento) {
            this.modalEventoSelecionado = true
            this.eventoSelecionado = evento
        },
        fecharModalEventoSelecionado() {
            this.modalEventoSelecionado = false
            this.eventoSelecionado = null
        },
        async fecharModalComAtualizacao() {
            this.fecharModalEventoSelecionado()
            await this.buscarModalMaisEventos()
        }
    }
}

</script>

<style scoped lang="stylus">

.max-15
    max-width 15vw

.container-principal
    overflow-y auto
    height 500px

.container-evento-item
    border-radius 5px
    background-color var(--cor-dentista)
    margin-bottom 10px
    padding 10px
    display flex
    justify-content space-between
    font-weight bold
    color white

    label:hover
        cursor pointer

.container-evento-item:hover
    cursor pointer
    opacity 0.5


</style>